<template>
  <div class="recycler-table">
    <div class="recycler-header recycler-flex">
      <span
        v-for="(header, idx) in modifiedHeaders"
        :key="`${idx}${header.value}`"
        :ref="header.value"
        @click="sort(header)"
        :class="idx == 0 ? 'fixed-col cell' : 'cell'"
      >
      {{ header.key }}
        <v-icon v-show="sortBy != header.key && sortBy != header.value" small color="primaryText">arrow_upward</v-icon>
        <v-icon v-show="sortBy === header.value && !sortDesc" small color="primaryText">arrow_upward</v-icon>
        <v-icon v-show="sortBy === header.value && sortDesc" small color="primaryText">arrow_downward</v-icon>
      </span>
    </div>
    <RecycleScroller
      class="recycler--height"
      :items="tableData"
      :key-field="key_field"
      :item-size="40"
      :buffer="100"
    >
      <template slot="default" slot-scope="{ item, index }">
        <span
          v-for="(header, idx) in modifiedHeaders"
          :key="`${index}${idx}${header.value}`"
          @click="sort(header)"
          :class="
            idx == 0
              ? 'fixed-col cell'
              : item[header.value] == null || item[header.value] == 'No Data'
              ? 'error--text cell'
              : 'number--text cell'
          "
        >
          {{
            header.value.includes("Breaker Status") ||
            header.value.includes("SPD Status")
              ? item[header.value] == null
                ? "NA"
                : item[header.value]
              : item[header.value] != null
              ? item[header.value]
              : "null"
          }}
        </span>
      </template>
    </RecycleScroller>
  </div>
</template>

<script>
export default {
  props: ["headers", "items", "key_field"],
  data() {
    return {
      tableData: [],
      sortBy: '',
      sortDesc: false,
    }
  },
  computed: {
    modifiedHeaders() {
      const headers = this.headers.map(header => ({ ...header, sortable: true }));
      return headers;
    },
  },
  mounted() {
    this.tableData = []
    if (this.items.length == 0) {
      const newItem = {};
      this.headers.forEach((el) => {
        newItem[el.value] = "No Data";
      });
      this.tableData.push(newItem);
    } else {
      this.tableData = _.cloneDeep(this.items)
    }

    this.$el
      .querySelector(".recycler-header")
      .addEventListener("scroll", (e) => {
        let recyclerWrapper = this.$el.querySelector(".vue-recycle-scroller");
        recyclerWrapper.scrollLeft = e.target.scrollLeft;
      });

    this.$el
      .querySelector(".vue-recycle-scroller")
      .addEventListener("scroll", (e) => {
        let recyclerHeader = this.$el.querySelector(".recycler-header");
        recyclerHeader.scrollLeft = e.target.scrollLeft;
      });
  },
  methods: {
    sort(column) {
      if (column.sortable) {
        if (this.sortBy === column.value) {
          this.sortDesc = !this.sortDesc;
        } else {
          this.sortBy = column.value;
          this.sortDesc = false;
        }
        const modifier = this.sortDesc ? -1 : 1;
        console.log(this.sortBy,"sort by")
        const sortedItems = [...this.tableData].sort((a, b) => {
          if(a['date_frame'] != 'Total' && b['date_frame'] != 'Total') {
            if(a[this.sortBy] != null && b[this.sortBy] != null) {
              if(this.sortBy != 'date_frame' && this.sortBy != 'sensor_time') {
                if (parseFloat(a[this.sortBy]) < parseFloat(b[this.sortBy])) return -1 * modifier;
                if (parseFloat(a[this.sortBy]) > parseFloat(b[this.sortBy])) return 1 * modifier;
              } else {
                if (a[this.sortBy] < b[this.sortBy]) return -1 * modifier;
                if (a[this.sortBy] > b[this.sortBy]) return 1 * modifier;
              }
            } else if(a[this.sortBy] == null) {
              return -1 * modifier;
            } else if(b[this.sortBy] == null) {
              return 1 * modifier;
            }
          }
          return 0;
        });

        this.tableData = sortedItems;
      }
    },
  },
  watch: {
    items() {
      this.tableData = []
      if (this.items.length == 0) {
        const newItem = {};
        this.headers.forEach((el) => {
          newItem[el.value] = "No Data";
        });
        this.tableData.push(newItem);
      } else {
        this.tableData = _.cloneDeep(this.items)
      }
      this.$el.querySelector(".vue-recycle-scroller").scrollTop = 0;
    },
  },
};
</script>

<style scoped>
.recycler--height {
  height: calc(100vh - 27rem);
}

.recycler-table {
  display: grid;
}

.recycler-header {
  overflow-x: scroll;
  height: 55px;
  max-height: 55px;
}

.recycler-row {
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.12);
}

.cell {
  width: 200px;
  padding: 10px;
  text-align: center;
  min-width: 200px;
}

.fixed-col {
  background-color: var(--v-primary-base);
  position: sticky;
  left: 0;
}

.recycler-flex {
  display: flex;
}
</style>

<style>
.theme--dark .vue-recycle-scroller__item-view {
  display: flex;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.12);
}

.theme--light .vue-recycle-scroller__item-view {
  display: flex;
  border-bottom: 1px solid black;
}

.vue-recycle-scroller__item-wrapper {
  overflow: visible;
}

.vue-recycle-scroller.ready.direction-vertical
  .vue-recycle-scroller__item-view {
  width: auto;
}
</style>